import React from 'react';
import { connect } from 'react-redux';

import history from '../../history';
import SubHeader from './SubHeader';
import bookImg from '../../images/book.png';
import { setQuery } from '../../actions/doaAction';
import api from '../../api/api';
import uri from '../../variables/uri';

class Release extends React.Component {
    componentDidMount() {
        if (!this.props.isAuthen) {
            history.push(`/home/${this.props.match.params.userId}`)
        }
    }

    onSelectedBook = async (book) => {
        try {
            const response = await api.get(`${uri.GET_BOOK_RELEASE}?bookCode=${book.BookCode}`)
            this.props.setQuery({ key: 'selectedBookRelease', value: book })
            this.props.setQuery({ key: 'bookReleaseList', value: response.data })
        } catch (ex) {

        } finally {
            history.push(`/settings/release/${book.BookCode}`)
        }
    }

    render() {
        return (
            <div className="flex-v home">
                <div className="flex-v flex-1">
                    <SubHeader text="Manage Release" />
                </div>
                <div className="flex-h flex-center mr-16 ml-16 mt-24 mb-24" style={{ flexWrap: 'wrap' }}>
                    {this.props.bookList.map((ele, i) => {
                        return (
                            <div onClick={() => this.onSelectedBook(ele)} className="card pt-8 pb-8 pl-24 pr-24 mb-16 mr-8 ml-8 flex-h" style={{ width: '280px', cursor: 'pointer' }} key={i}>
                                <img className="center" src={bookImg} style={{ width: '30px' }} alt="" />
                                <div className="flex-1 flex-v ml-24">
                                    <h4 style={{ opacity: '0.7' }}>{ele.BookCode}</h4>
                                    <h3>{ele.BookName}</h3>
                                    <h5>Current Version: <span style={{ color: 'rgb(130, 44, 61)' }}>{ele.BookReleaseVersion}</span></h5>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthen: state.auth.isAuthen,
        bookList: state.doa.queryBookList
    }
}

export default connect(mapStateToProps, {
    setQuery
})(Release)